import { useEffect, useState } from "react";

const mapsLoaded = () => !!(window.google && window.google.maps && window.google.maps.Map)

// 'loading' | 'ready' | 'failed'
//
// The Google Maps script is loaded by public/index.html (the location form needs it at module
// level), so a page that needs the map waits for it here instead of injecting a second copy.
// It gives up after about 15 seconds (no network, or a rejected API key).
export const useMapsReady = () => {
  const [state, setState] = useState(mapsLoaded() ? "ready" : "loading")

  useEffect(() => {
    if (state !== "loading") return undefined
    let tries = 0
    const timer = setInterval(() => {
      tries++
      if (mapsLoaded()) {
        setState("ready")
        clearInterval(timer)
      } else if (tries >= 50) {
        setState("failed")
        clearInterval(timer)
      }
    }, 300)
    return () => clearInterval(timer)
  }, [state])

  return state
}
